import React, { useState } from "react";
import { Chip } from "@mui/material";
export default function Chips({ label, activeTab, index, handleClick }) {
  return (
    <Chip
      onClick={() => handleClick(index)}
      label={label}
      // className="__siki_chip"
      sx={{
        color: activeTab === index ? "#000000" : "#999999",
        cursor: activeTab === index ? "default" : "pointer",
        "&:hover":
          activeTab === index
            ? {}
            : {
                backgroundColor: "#000000 !important",
                borderColor: "#ffffff !important",
                color: "#ffffff",
              },
      }}
      color={activeTab === index ? "primary" : "default"}
      variant={activeTab === index ? "filled" : "outlined"}
    />
  );
}
